import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _toArray from "@babel/runtime/helpers/toArray";
import React from 'react';
export var formatStringMessage = function formatStringMessage(message, variables) {
  return formatMessage(message, variables).filter(assertString).join('');
};
export var formatReactMessage = function formatReactMessage(message, variables) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, formatMessage(message, variables).map(function (e, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, e);
  }));
};
export var formatMessage = function formatMessage(message, variables) {
  return message.split(/({[A-z]*})/g).map(getVariableValues(variables)).reduce(concatStringsReducer, []);
};
var getVariableValues = function getVariableValues(variables) {
  return function (input) {
    var variableName = input.slice(1, -1);
    var variableValue = variables === null || variables === void 0 ? void 0 : variables[variableName];
    return variableValue === undefined ? input : variableValue;
  };
};
var concatStringsReducer = function concatStringsReducer(accumulator, current) {
  var _reverse = _toConsumableArray(accumulator).reverse(),
    _reverse2 = _toArray(_reverse),
    previous = _reverse2[0],
    rest = _reverse2.slice(1);
  if (typeof current === 'string' && typeof previous === 'string') {
    return ["".concat(previous).concat(current)].concat(_toConsumableArray(rest)).reverse();
  }
  return [].concat(_toConsumableArray(accumulator), [current]);
};
var assertString = function assertString(s) {
  return typeof s === 'string';
};